import React from 'react';

const Volume = () => {
  return (
    <svg
      fill="none"
      height="12"
      viewBox="0 0 15 12"
      width="15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.97762 11.1921V0.789062L3.3017 3.89764H0.12207V8.19949H3.3017"
        fill="white"
      />
      <path
        d="M12.8094 1.09007L12.6528 0.942383L11.8213 1.72607L11.9779 1.87375C14.4415 4.19625 14.4415 7.97555 11.9779 10.2981L11.8213 10.4458L12.6528 11.2294L12.8094 11.0818C15.7314 8.32702 15.7314 3.84479 12.8094 1.09007Z"
        fill="white"
      />
      <path
        d="M10.3571 2.96644L10.1843 2.81006L9.35352 3.5617L9.52636 3.71809C10.2235 4.34879 10.6073 5.18878 10.6073 6.08321C10.6073 6.97784 10.2235 7.81784 9.52636 8.44853L9.35352 8.60491L10.1843 9.35635L10.3571 9.19997C11.2779 8.36711 11.785 7.26036 11.785 6.08321C11.785 4.90605 11.2779 3.7993 10.3571 2.96644Z"
        fill="white"
      />
    </svg>
  );
};

export default Volume;
